import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        // No token (never signed in, or signed out) means signed out; the login page then shows without
        // first waiting for the API to reject the calendar's requests.
        isAuthenticated: Boolean(localStorage.getItem("token")),
        user: localStorage.getItem("user") || null,
        token: localStorage.getItem("token") || null,
        refreshToken: localStorage.getItem("refreshToken") || null,
        error: null,
        loading: false,
    },
    reducers: {
        login: (state, action) => {
            state.isAuthenticated = true;
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.error = null;
            state.loading = false;
            state.refreshToken = action.payload.refreshToken;
        },
        logout: (state) => {
            state.isAuthenticated = false;
            state.user = null;
            state.token = null;
            state.error = null;
            state.loading = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
    },
});

export const { login, logout, setError, setLoading } = authSlice.actions;

export default authSlice.reducer;